import Api from '../utils/Api';
import Config from '../config/Config';

class PersonaService {
  constructor() {
    this.url = Config.URL_SERVICE;
    this.api = new Api({ url: this.url });
    this.api.createEntities([{ name: 'socio' }]);
  }

  obtenerDatosPersona(token) {
    const config = { headers: { 'Authorization':  `Bearer ${token}` } };
    return this.api.endpoints.socio
      .get(config)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error;
      });
  }

  updateDatosPersona(trackId, datosPersona) {
    const config = { headers: { 'trackId': trackId } };
    const newDatosPersona = { "params": datosPersona }
    return this.api.endpoints.socio
      .update(newDatosPersona, config)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error;
      });
  }



}


export default new PersonaService;